import { Context as ContextBase } from "ckeditor5";
import { CommentsRepository, WideSidebar } from "ckeditor5-premium-features";

class Context extends ContextBase {}

export const createContext = ({ sidebarElement }) => {
  if (!sidebarElement) {
    return null;
  }

  // Plugins to include in the context.
  Context.builtinPlugins = [
    CommentsRepository, WideSidebar
  ];

  Context.defaultConfig = {
    // License Key
    licenseKey: "eyJhbGciOiJFUzI1NiJ9.eyJleHAiOjE4MTQxNDA3OTksImp0aSI6ImMzZGVhN2IwLWJlMDktNGM1Yy1iMmJlLTJmODZjODJmYzg1NCIsImRpc3RyaWJ1dGlvbkNoYW5uZWwiOlsic2giLCJkcnVwYWwiXSwid2hpdGVMYWJlbCI6dHJ1ZSwiZmVhdHVyZXMiOlsiRFJVUCIsIlRDIiwiQ01UIl0sInZjIjoiNTBkMDk0NmMifQ.ysS_gcqa7A0e9zq8J3u0Sglcfqok7zwO0GL9HWaZlkYvsmYSRnD_V9VgK35zbLz34jdKnBSTdnyqIQUUPWYrsQ",
    sidebar: {
      container: sidebarElement,
    },
    comments: {
      editorConfig: {},
    },
  };

  return Context;
};
